import * as React from "react";
import {useEffect} from "react";
import {CreateOrModifyTransportOrderDryRunRequest, TransportOrder} from "../../../../../generated";
import {backend} from "../../../../../xconvert-backend";
import {authentication} from "../../../../../authentication";
import {Dimmer, Grid, Loader, Modal} from "semantic-ui-react";
import DiffViewer from "react-diff-viewer";
import {configStorage} from "../../../../../ConfigStorage";
import {ConfigContext} from "../../../context/ConfigContext";
import {CustomDiff} from "../../configChange/configEdit/diff/CustomDiff";


export interface ImportSimCompareTwoOrderModalProps {
    isOpen: boolean
    onClose: () => void
    order1: TransportOrder
    order2: TransportOrder
}

export function ImportSimCompareTwoOrderModal(props: React.PropsWithChildren<ImportSimCompareTwoOrderModalProps>) {

    const context = React.useContext(ConfigContext)

    const [cleanedOrder1, setCleanedOrder1] = React.useState<TransportOrder>(null)
    const [cleanedOrder2, setCleanedOrder2] = React.useState<TransportOrder>(null)
    const [loaded1, setLoaded1] = React.useState<boolean>(false)
    const [loaded2, setLoaded2] = React.useState<boolean>(false)

    const auth = backend.withTokenAuthHeader(authentication.token)

    useEffect(() => {
        console.log("loading ")

        getCleaned(props.order1).then((o) => {
            setCleanedOrder1(o)
            setLoaded1(true)
        })
        getCleaned(props.order2).then((o) => {
            setCleanedOrder2(o)
            setLoaded2(true)
        })

    }, [props.isOpen]);

    async function getCleaned(order: TransportOrder) {
        let request = {} as CreateOrModifyTransportOrderDryRunRequest
        request.orders = [order]
        request.config =  (await configStorage.getElement(context.companyId)).config
        let rawResp = await fetch("/api/internal/createOrModifyDryRun", {
            method: 'POST',
            headers: {
                "Authorization": auth.headers.Authorization.toString(),
                "Content-Type": "application/json; charset=utf-8",
                "x-company-id": context.companyId,
            },
            body: JSON.stringify(request)
        })

        let responseText = await rawResp.text()
        let response = JSON.parse(responseText)

        return response.transportOrderResponses[0].transportOrder
    }

    function drawDiff() {
        let o1 = JSON.stringify(cleanedOrder1, null, 4)
        let o2 = JSON.stringify(cleanedOrder2, null, 4)


        return <CustomDiff
            oldJson={o1}
            newJson={o2}
        />
    }

    function loadingDone() {
        return loaded1 && loaded2
    }

    return <Modal
        open={props.isOpen}
        onClose={props.onClose}
        size={"fullscreen"}
        closeIcon
    >
        <Modal.Header>compare order {props.order1.externalTransportOrderId} with {props.order2.externalTransportOrderId}</Modal.Header>
        <Modal.Content>
            <Modal.Description>

                {!loadingDone() && <Dimmer active inverted>
                    <Loader inverted content='Loading'/>
                </Dimmer>}

                <Grid>
                    <Grid.Row>
                        <Grid.Column width={8} textAlign={"center"}>
                            Order 1: {props.order1.externalTransportOrderId}
                        </Grid.Column>
                        <Grid.Column width={8} textAlign={"center"}>
                            Order 2: {props.order2.externalTransportOrderId}
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                {loadingDone() && drawDiff()}

            </Modal.Description>
        </Modal.Content>
    </Modal>


}